import React from "react";
import { isMobile } from "react-device-detect";
import MorePortfolioMobile from "./MorePortfolioMobile";
import Accordion from "./Accordion";
import MorePortfolio from "./MorePortfolio";

import { BackgroundColor } from "./StyledComponents/BackgroundStyle.style";

import PictureHover from "./asset/pictures/tropical_junglee.jpg";

const Portfolio = () => {
  return (
    <>
      <BackgroundColor backgroundImg={PictureHover}>
        <Accordion
          title="PORTFOLIO - PORTFOLIO - PORTFOLIO - PORTFOLIO - PORTFOLIO - PORTFOLIO
- PORTFOLIO - PORTFOLIO"
        >
          {isMobile ? <MorePortfolioMobile /> : <MorePortfolio />}
        </Accordion>
      </BackgroundColor>
    </>
  );
};

export default Portfolio;
